import Avatar from './avatar'
export * from './avatar'
export default Avatar
export type { AvatarProps } from './avatar'
